import React from 'react';

type IconProps = {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
};

const UserIcon = ({ size = 19, style, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 19 19"
      className={className}
      style={style}
    >
      <path
        fill="currentColor"
        d="M9.5,8A9.5,9.5,0,1,0,19,17.5,9.5,9.5,0,0,0,9.5,8Zm4.9,16.15a8.213,8.213,0,0,1-9.806,0v-.521a2.454,2.454,0,0,1,2.452-2.452,11.144,11.144,0,0,0,2.452.437,11.144,11.144,0,0,0,2.452-.437A2.454,2.454,0,0,1,14.4,23.629ZM15.575,23.1a3.666,3.666,0,0,0-3.624-3.145c-.785,0-1.165.437-2.452.437s-1.662-.437-2.452-.437A3.666,3.666,0,0,0,3.425,23.1a8.274,8.274,0,1,1,12.151,0ZM9.5,12.29a3.371,3.371,0,1,0,3.371,3.371A3.371,3.371,0,0,0,9.5,12.29Zm0,5.516a2.145,2.145,0,1,1,2.145-2.145A2.147,2.147,0,0,1,9.5,17.806Z"
        transform="translate(0 -8)"
      />
    </svg>
  );
};

export default UserIcon;
